import React, { useEffect, useState } from 'react';

const FloatingHearts = () => {
    const [hearts, setHearts] = useState([]);

    useEffect(() => {
        const newHearts = Array.from({ length: 15 }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * 5,
            duration: 3 + Math.random() * 4,
            size: 20 + Math.random() * 40,
            opacity: 0.1 + Math.random() * 0.3,
        }));
        setHearts(newHearts);
    }, []);

    return (
        <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
            {hearts.map((heart) => (
                <div
                    key={heart.id}
                    className="absolute text-dulce-pink-300"
                    style={{
                        left: `${heart.left}%`,
                        bottom: '-20px',
                        fontSize: `${heart.size}px`,
                        opacity: heart.opacity,
                        animation: `floatUp ${heart.duration}s ease-in-out ${heart.delay}s infinite`,
                    }}
                >
                    ♥
                </div>
            ))}
        </div>
    );
};

export default FloatingHearts;